import React, { FC } from 'react';

import {
	EvBodyDefault,
	EvFlexColumn,
	EvFlexRow,
	EvHeadingLarge,
	EvIcon,
	EvLink,
	FLEX_ALIGN,
	FLEX_GAP,
	InfoMsgMarkIcon,
	SmallBackIcon
} from '@evinced-private/ui-common';

import {
	WFA_DASHBOARD_LAST_UPDATED_DAID,
	WFA_DASHBOARD_TITLE_DAID
} from 'data-automation-ids/WfaDashboardAutomationIds';
import { BusinessUnitSelector } from 'src/apps/dashboard/components/business-unit-selector/BusinessUnitSelector';
import { LastUpdated } from 'src/apps/dashboard/components/last-updated';
import { DASHBOARD_LABELS } from 'src/common/labels/dashboard.labels';

import { DashboardTemplateHeaderProps } from './DashboardTemplateHeader.types';

export const DashboardTemplateHeader: FC<DashboardTemplateHeaderProps> = ({
	header,
	dashboardLastUpdatedAt,
	scoreLastUpdatedAt
}) => {
	const {
		showBusinessUnitSelector,
		backLink,
		title,
		titleId,
		showMobileBanner,
		description,
		descriptionId,
		showLastUpdated
	} = header;

	return (
		<EvFlexColumn gap="MEDIUM">
			{showBusinessUnitSelector && <BusinessUnitSelector />}
			{backLink && (
				<EvLink
					url={backLink.url}
					customLink={
						<EvFlexRow gap={FLEX_GAP.SMALL} align={FLEX_ALIGN.CENTER}>
							<EvIcon icon={SmallBackIcon} small />
							<span>{backLink.text ?? DASHBOARD_LABELS.BACK}</span>
						</EvFlexRow>
					}
					onClick={backLink.onClick}
				/>
			)}
			{title && (
				<EvHeadingLarge as="h1" id={titleId} dataAutomationId={WFA_DASHBOARD_TITLE_DAID}>
					{title}
				</EvHeadingLarge>
			)}
			{showMobileBanner && (
				<EvFlexRow gap="SMALL">
					<EvIcon icon={InfoMsgMarkIcon} small />
					<EvBodyDefault>{DASHBOARD_LABELS.MOBILE_DASHBOARD_INFO_BANNER}</EvBodyDefault>
				</EvFlexRow>
			)}
			{description && <EvBodyDefault id={descriptionId}>{description}</EvBodyDefault>}
			{showLastUpdated && (
				<LastUpdated
					firstUpdatedAt={dashboardLastUpdatedAt}
					secondUpdatedAt={scoreLastUpdatedAt}
					dataAutomationId={WFA_DASHBOARD_LAST_UPDATED_DAID}
				/>
			)}
		</EvFlexColumn>
	);
};
